export default {
      id: "180,1=1,7+80+70+28,4-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#180,1=1,7+80+70+28,4",
      toString: function () {
        return this.url;
      }
    }